import React from "react";

/**
 * 顶层错误边界：模拟循环里的意外异常不会让页面变成白屏，
 * 而是显示可读的错误信息与恢复入口（战局进度可能丢失，元数据存档不受影响）。
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[SanguoSandbox] 未捕获异常：", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh", background: "#1c1712", color: "#e8dcc1",
        fontFamily: "'Songti SC','Noto Serif SC',serif",
        display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 14, padding: 24, textAlign: "center",
      }}>
        <h1 style={{ color: "#d4b24c", letterSpacing: 6, margin: 0 }}>三国·沙盘</h1>
        <p style={{ color: "#c07a6c" }}>⚠ 运行中遇到意外错误</p>
        <pre style={{
          maxWidth: 640, overflow: "auto", fontSize: 12, textAlign: "left",
          background: "#26201640", border: "1px solid #6b5a3e",
          borderRadius: 4, padding: 12, color: "#e8dcc1",
        }}>{String(this.state.error?.stack || this.state.error)}</pre>
        <button onClick={() => window.location.reload()} style={{
          background: "#2f4a2c", color: "#e8dcc1", border: "1px solid #6b5a3e",
          borderRadius: 3, padding: "8px 22px", cursor: "pointer",
          fontFamily: "inherit", fontSize: 15, fontWeight: 700,
        }}>↺ 重新载入</button>
      </div>
    );
  }
}
